const routes = [

	// Note: 2025-01-02, jsnelders: All routes used to be directly in this array.
	//	They have now been split out into files for each module or logical grouping of
	//	related functionality for each management. Folllow the pattern when adding
	//	new modules or areas.


]



import publicRoutes from "./routes.public.js";
routes.push(...publicRoutes);

import otherRoutes from "./routes.other.js";
routes.push(...otherRoutes);

import reportsRoutesV1 from "./routes.reportsV1.js";
routes.push(...reportsRoutesV1);

import timesheetsRoutes from "./routes.timesheets.js";
routes.push(...timesheetsRoutes);

import myProfileRoutes from "./routes.my-profile.js";
routes.push(...myProfileRoutes);

import accountAdminRoutes from "./routes.account-admin.js";
routes.push(...accountAdminRoutes);

import manageRoutes from "./routes.manage.js";
routes.push(...manageRoutes);

import systemAdminRoutes from "./routes.system-admin.js";
routes.push(...systemAdminRoutes);

import developersRoutes from "./routes.developers.js";
routes.push(...developersRoutes);

import testRoutes from "./routes.developers.testing.js";
routes.push(...testRoutes);

import mobileAppRoutes from "./routes.mobile-app.js";
routes.push(...mobileAppRoutes);

import rosteringRoutes from "./routes.rostering.js";
routes.push(...rosteringRoutes);

import valenHrRoutes from "./routes.valen-hr.js";
routes.push(...valenHrRoutes);



//-- 2026 uplift
import adminRoutes from "./routes.admin.js";
routes.push(...adminRoutes);

import projectsRoutes from "./routes.projects.js";
routes.push(...projectsRoutes);

import reportsRoutes2 from "./routes.reports.js";
routes.push(...reportsRoutes2);

import resourcePlanningRoutes from "./routes.resource-planning.js";
routes.push(...resourcePlanningRoutes);

import crmRoutes from "./routes.crm.js";
routes.push(...crmRoutes);



// Catch-all: must stay last, since Vue Router matches routes in array order.
routes.push({
	path: '/:pathMatch(.*)*',
	name: "not-found-catch-all",
	component: () => import("/unauthenticated/not-found.vue"),
	meta: { layout: "public", layoutByAuth: true, isPublic: true, module: "", parentRouteName: "", pageTitle: "Not Found" }
});



export default routes;